module.exports = __webpack_public_path__ + "img/11rm@2x.3e7dc8b5.png";